/* WTF drawer cart (2026-10-04, Jeff): every on-site "View cart" link opens the cart drawer instead of loading /cart.
   Loaded by snippets/cart-drawer.liquid, so it runs only while cart_type = drawer. The /cart page stays as the fallback:
   no JS, a modified click (new tab), a link inside the drawer or the B2G1 sheet, or a page with no drawer all keep the normal link.
   The header cart icon is handled by the theme's own cart-drawer.js, so it is skipped here.
   Before opening, the drawer HTML is refreshed from the server (800 ms limit), because a cart change made outside the theme's
   add button (the B2G1 sheet) does not re-render the drawer. */
(function () {
  'use strict';
  if (window.__wtfCartLinks) return;
  window.__wtfCartLinks = true;

  function cartPath() { return ((window.routes && window.routes.cart_url) || '/cart').replace(/\/$/, ''); }

  function isCartLink(a) {
    try {
      var u = new URL(a.getAttribute('href'), window.location.href);
      return u.origin === window.location.origin && u.pathname.replace(/\/$/, '') === cartPath();
    } catch (e) { return false; }
  }

  function refresh(dr) {
    return fetch(cartPath() + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        var tgt = document.getElementById('CartDrawer');
        if (!src || !tgt || dr.classList.contains('active')) return;
        tgt.innerHTML = src.innerHTML;
        dr.classList.toggle('is-empty', !!src.querySelector('.drawer__inner-empty'));
        var ov = dr.querySelector('#CartDrawer-Overlay');
        if (ov) ov.addEventListener('click', dr.close.bind(dr));
      });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || !isCartLink(a)) return;
    if (a.id === 'cart-icon-bubble' || a.closest('#cart-icon-bubble')) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download') || a.hasAttribute('data-wtf-no-drawer') || a.hasAttribute('data-b2g1-ph-open')) return;
    if (a.closest('cart-drawer') || a.closest('#wtf-b2g1')) return;
    if (window.location.pathname.replace(/\/$/, '') === cartPath()) return; /* already on the cart page */
    var dr = document.querySelector('cart-drawer');
    if (!dr || typeof dr.open !== 'function') return;
    e.preventDefault();
    var wait = new Promise(function (resolve) { window.setTimeout(resolve, 800); });
    Promise.race([refresh(dr).catch(function () {}), wait]).then(function () { dr.open(a); });
  });
})();

/* WTF drawer "Check out tapped" counter (Jeff, page R467, 10-06 12:37 AM AZ: "add"). Why: compare Check out taps in the drawer
   with Shopify's "reached checkout" count, to see whether real taps turn into checkouts.
   One Google Analytics 4 event, "wtf_checkout_tap", per tap on #CartDrawer-Checkout, sent through the page's own gtag
   (sections/wtf-google-tag.liquid, Google tag GT-PBN5VLS2). It never cancels, delays or changes the tap: no preventDefault, no
   stopPropagation, no wait, no request of its own, every error swallowed. No Meta pixel call, no Shopify custom event.
   A capture listener on document: a drawer re-render (a new button) needs no re-binding, and no other click listener can hide the tap. */
(function () {
  'use strict';
  if (window.__wtfCheckoutTap) return;
  window.__wtfCheckoutTap = true;
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target && e.target.closest ? e.target.closest('#CartDrawer-Checkout') : null;
      if (!btn || btn.disabled) return;
      if (typeof window.gtag !== 'function') return;
      window.gtag('event', 'wtf_checkout_tap', { wtf_source: 'cart_drawer' });
    } catch (err) { /* never block Check out */ }
  }, true);
})();
